import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icon-warning.svg'


const _hoisted_1 = { class: "jr-w-full jr-h-screen jr-m-auto jr-fixed jr-top-0 jr-z-60 jr-flex jr-items-center" }
const _hoisted_2 = { class: "jr-relative jr-min-w-652 jr-min-h-68 jr-bg-white jr-m-auto jr-p-4 jr-text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "jr-text-center jr-mt-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "jr-m-auto",
    src: _imports_0,
    alt: "icon-warning"
  })
], -1)
const _hoisted_4 = { class: "jr-text-xl jr-text-primary jr-mt-6.5 jr-font-bold" }
const _hoisted_5 = { class: "jr-mx-auto jr-text-primary jr-mt-5 jr-w-full jr-text-sm" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "jr-mb-8 jr-mt-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "jr-bg-black jr-w-full jr-h-screen jr-opacity-20 jr-z-50 jr-fixed" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIButton = _resolveComponent("UIButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("figure", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: "jr-whitespace-pre",
                textContent: _toDisplayString(_ctx.message)
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_UIButton, {
                type: _ctx.ButtonType.classic,
                label: _ctx.cancel,
                onClick: _ctx.onCancel,
                class: "jr-inline-block jr-py-2 jr-w-40 jr-m-0 jr-rounded-md jr-text-center jr-text-sm jr-mr-2"
              }, null, 8, ["type", "label", "onClick"]),
              _createVNode(_component_UIButton, {
                type: _ctx.ButtonType.primary,
                label: _ctx.submit,
                onClick: _ctx.onSubmit,
                class: "jr-inline-block jr-py-2 jr-w-40 jr-m-0 jr-rounded-md jr-text-center jr-text-sm jr-mr-2"
              }, null, 8, ["type", "label", "onClick"])
            ])
          ])
        ]),
        _hoisted_8
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }))
}